import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import HomeSlider from './components/HomeSlider';
import AboutSection from './components/AboutSection';
import WorkSection from './components/WorkSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import ImpactSection from './components/ImpactSection';
import ProgrammesSection from './components/ProgrammesSection';
import SDGSection from './components/SDGSection';
import ContactSection from './components/ContactSection';
import SupportCauseSection from './components/SupportCauseSection';
import AboutUs from './components/AboutUs';
import FixedButtons from './components/FixedButtons';
import SocialMediaIcons from './components/SocialMediaIcons';
import EventsSection from './components/EventsSection';
import BecomeMember from './components/BecomeMember';
import Volunteer from './components/Volunteer';
import Donate from './components/Donate';
import GallerySection from './components/GallerySection';
import BlogsSection from './components/BlogsSection';
import Dashboard from './components/Dashboard';
import CoreTeam from './components/CoreTeam';
import Mentors from './components/Mentors';
import Education from './components/Education';
import Environment from './components/Environment';
import WomenEmpowerment from './components/WomenEmpowerment';
import Health from './components/Health';
import Livelihood from './components/Livelihood';
import Privacy_Policy from './components/Privacy_Policy'
import '@fortawesome/fontawesome-free/css/all.min.css';
import Layout from "./components/Layout";
import { HelmetWrapper } from './HelmetWrapper';

// प्लेसहोल्डर पेज
const Certification: React.FC = () => <div className="py-5 text-center"><h2>Certification Page</h2></div>;
const Team: React.FC = () => <div className="py-5 text-center"><h2>Team Page</h2></div>;
const Contact: React.FC = () => (
  <div className="py-5">
    <ContactSection />
  </div>
);

const Home: React.FC = () => {
  return (
    <>
      <HomeSlider />
      <AboutSection />
      <ProgrammesSection />
      <EventsSection />
      <WorkSection />
      <ImpactSection />
      <TestimonialSection />
      <SDGSection />
      <SupportCauseSection />
      <CTASection />
      <ContactSection />
    </>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<>  <HelmetWrapper/><Header /><Home /><FixedButtons /><SocialMediaIcons /><Footer /></>} />
            <Route path="/about/" element={<><HelmetWrapper/><Header /><AboutUs /><FixedButtons /><SocialMediaIcons /><Footer /></>} />
            <Route path="/media/" element={<><HelmetWrapper/><HelmetWrapper/><Header /><GallerySection /><FixedButtons /><SocialMediaIcons /><Footer /></>} />
            <Route path="/certification" element={<><HelmetWrapper/><Header /><Certification /><FixedButtons /><SocialMediaIcons /><Footer /></>} />
            <Route path="/team" element={<><HelmetWrapper/><Header /><Team /><FixedButtons /><SocialMediaIcons /><Footer /></>} />
            <Route path="/blogs/" element={<><HelmetWrapper/><Header /><BlogsSection /><FixedButtons /><SocialMediaIcons /><Footer /></>} />
            <Route path="/contact/" element={<><HelmetWrapper/><Header /><Contact /><FixedButtons /><SocialMediaIcons /><Footer /></>} />
            <Route path="/become-member/" element={<><HelmetWrapper/><Header /><BecomeMember /><FixedButtons /><SocialMediaIcons /><Footer /></>} />
            <Route path="/volunteer" element={<><HelmetWrapper/><Header /><Volunteer /><FixedButtons /><SocialMediaIcons /><Footer /></>} />
            <Route path="/donate/" element={<><HelmetWrapper/><Header /><Donate /><FixedButtons /><SocialMediaIcons /><Footer /></>} />
            <Route path="/dashboard/*" element={<Dashboard />} />
            <Route path="/core-team/" element={<><HelmetWrapper/><Header /><CoreTeam /><FixedButtons /><SocialMediaIcons /><Footer /></>} />
            <Route path="/mentors/" element={<><HelmetWrapper/><Header /><Mentors /><FixedButtons /><SocialMediaIcons /><Footer /></>} /> {/* Add this line */}
            <Route path="/education/" element={<><HelmetWrapper/><Header /><Education /><FixedButtons /><SocialMediaIcons /><Footer /></>} /> {/* Add this line */}
            <Route path="/women-empowerment/" element={<><HelmetWrapper/><Header /><WomenEmpowerment /><FixedButtons /><SocialMediaIcons /><Footer /></>} /> {/* Add this line */}
            <Route path="/environment/" element={<><HelmetWrapper/><Header /><Environment /><FixedButtons /><SocialMediaIcons /><Footer /></>} /> {/* Add this line */}
            <Route path="/health/" element={<><HelmetWrapper/><Header /><Health /><FixedButtons /><SocialMediaIcons /><Footer /></>} />
            <Route path="/livelihood/" element={<><HelmetWrapper/><Header /><Livelihood /><FixedButtons /><SocialMediaIcons /><Footer /></>} />
            <Route path="/privacy-policy/" element={<><HelmetWrapper/><Header /><Privacy_Policy /><FixedButtons /><SocialMediaIcons /><Footer /></>} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
};

export default App;